import { render, staticRenderFns } from "./SetComponentItem.vue?vue&type=template&id=6813ea08&"
import script from "./SetComponentItem.vue?vue&type=script&lang=js&"
export * from "./SetComponentItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/danielkaschlaw/Desktop/Sites/devTools_shit/37375/11/myneStore/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6813ea08')) {
      api.createRecord('6813ea08', component.options)
    } else {
      api.reload('6813ea08', component.options)
    }
    module.hot.accept("./SetComponentItem.vue?vue&type=template&id=6813ea08&", function () {
      api.rerender('6813ea08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/basket/list/SetComponentItem.vue"
export default component.exports